const GENERIC_EXCEPTION_NAMES = new Set([
  'Error',
  'TypeError',
  'ReferenceError',
  'RangeError',
  'SyntaxError',
]);

const coerceApiErrorMessage = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }
  if (!value || typeof value !== 'object') {
    return null;
  }
  const record = value as Record<string, unknown>;
  if (typeof record.message === 'string' && record.message.trim()) {
    return record.message;
  }
  if (typeof record.error === 'string' && record.error.trim()) {
    if (!GENERIC_EXCEPTION_NAMES.has(record.error.trim())) {
      return record.error;
    }
  }
  if (record.error) {
    return coerceApiErrorMessage(record.error);
  }
  return null;
};

/**
 * Best human-readable message from an axios error against the Nova ops proxy:
 * enveloped `{ error: { message } }`, bare `{ message }`, plain string bodies,
 * then the transport error, then the caller's fallback.
 */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  const error = err as {
    response?: { data?: { message?: unknown; error?: unknown } | unknown };
    message?: unknown;
  } | null;
  const data = error?.response?.data as
    | { message?: unknown; error?: unknown }
    | undefined;
  return (
    coerceApiErrorMessage(data?.message) ??
    coerceApiErrorMessage(data?.error) ??
    coerceApiErrorMessage(data) ??
    (typeof error?.message === 'string' && error.message.trim()
      ? error.message
      : null) ??
    fallback
  );
};
